import ListMenu, { type ListMenuNavItem } from '@rio-cloud/rio-uikit/ListMenu';
import partial from 'lodash/fp/partial';

import { config } from '../../config';
import { chapters } from './chapters';
import { ServiceInfoDialogMenuItem } from './ServiceInfoDialogMenuItem';

const buildNavItem = (
    activeChapter: string,
    onClick: (event: React.MouseEvent<HTMLSpanElement>) => void,
    props: any
): ListMenuNavItem => ({
    key: props.chapter,
    item: <ServiceInfoDialogMenuItem activeChapter={activeChapter} onClick={onClick} {...props} />,
});

const getMenuItems = (activeChapter: string, onClick: (event: React.MouseEvent<HTMLSpanElement>) => void) => {
    const buildItem = partial(buildNavItem, [activeChapter, onClick]);
    const applicationName = config.applicationName;
    return [
        {
            group: applicationName,
            navItems: [
                buildItem({
                    chapter: chapters.welcome,
                }),
                buildItem({
                    chapter: chapters.whatsNew,
                }),
                buildItem({
                    chapter: chapters.feedback,
                }),
            ],
        },
    ];
};

type ServiceInfoDialogMenuProps = {
    chapter: string;
    onSelectChapter: (event: React.MouseEvent<HTMLSpanElement>) => void;
};

export const ServiceInfoDialogMenu = ({ chapter, onSelectChapter }: ServiceInfoDialogMenuProps) => (
    <ListMenu menuItems={getMenuItems(chapter, onSelectChapter)} groupClassName='padding-left-0' />
);
